// Copyright (c) StrangeBee 2024

import { Route as AlertStatusRoute } from './AlertStatus/List';
import { Route as CaseStatusRoute } from './CaseStatus/List';
import { Route as AttackPatternsListRoute } from './AttackPatterns/List';
import { Route as AttackPatternsDetailsRoute } from './AttackPatterns/Details';
import { Route as AnalyzerTemplatesListRoute } from './AnalyzerTemplates/List';
import { Route as CustomFieldsListRoute } from './CustomFields/List';
import { Route as ObservablesListRoute } from './Observables/List';
import { Route as ProfilesListRoute } from './Profiles/List';
import { Route as TaxonomiesListRoute } from './Taxonomies/List';

export default [
    ProfilesListRoute,
    CustomFieldsListRoute,
    ObservablesListRoute,
    CaseStatusRoute,
    AlertStatusRoute,

    AnalyzerTemplatesListRoute,
    TaxonomiesListRoute,
    AttackPatternsListRoute,
    AttackPatternsDetailsRoute,
];
